
module.cC({
    name: 'EducationProfileController',

    inject: ['$scope', 'ModelService', 'filterFilter', 'orderByFilter',
             'brandeisActivityFields', 'educationProfile', 'educationTests',
             'brandeisData'],

    data: {
        profile: 'educationProfile',
        tests: 'educationTests',
        testTypes: [['reading', 'Reading'], ['math', 'Math']],
        brandeisData: 'brandeisData',
        brandeisActivityFields: 'brandeisActivityFields',
    },

    listen: {
        education_test: {
            create: function(id, ownerId) {
                if (ownerId === this.profile.id) {
                    this.ModelService.get('education_test', id)
                        .then(this.ModelService.appendToArray(this.tests));
                }
            },
            delete: function(id) {
                this.ModelService.removeById('education_test', id, this.tests);
            },
        },
    },

    computed: {
        earlyCredential: {
            watch: ['student.exited',
                    'profile.credential_at_entry',
                    'profile.credential_awarded'],

            get: function() {
                if (this.$.student.exited || this.$.profile.credential_at_entry !== 'none') {
                    return 'ineligible';
                } else if (this.$.profile.credential_awarded) {
                    return 'yes';
                } else {
                    return 'no';
                }
            }
        }
    },

    methods: {

        filterTests: function(tests, type) {
            tests = this.filterFilter(tests, {test_type: type});
            return this.orderByFilter(tests, 'test_date');
        },
    },

});